<section class="section-title">

  <h1 i18n="@@register_title">Registrazione</h1>
  <p i18n="@@register_text">Per registrarti compila i campi richiesti</p>

</section>

<section>

  <div class="control-card-white no-border" id="register-card">

    <div class="control-card-content">

      <label for="userEmail" i18n="@@register_email">Indirizzo email</label><br />
      <input id="userEmail" type="email" placeholder="Email" class="margin-top-10" #userEmail required autofocus (keyup.enter)="register(userEmail.value, userPassword.value, userPassword2.value)">

      <br/><br/>

      <label for="userPassword" i18n="@@register_password">Password</label><br />
      <input id="userPassword" type="password" placeholder="Password" class="margin-top-10" #userPassword required (keyup.enter)="register(userEmail.value, userPassword.value, userPassword2.value)">
      
      <br /><br />

      <label for="userPassword2" i18n="@@register_password_again">Ripeti Password</label><br />
      <input id="userPassword2" type="password" placeholder="Password" class="margin-top-10" #userPassword2 required (keyup.enter)="register(userEmail.value, userPassword.value, userPassword2.value)">

      <br />

      <br /><br />

      <div id="privacy" style="overflow-y:scroll; overflow-x:hidden; width:100%; height:180px;">
        <app-privacy></app-privacy>
      </div>
      
      <div id="terms" class="margin-top-20" style="overflow-y:scroll; overflow-x:hidden; width:100%; height:180px;">
        <app-terms></app-terms>
      </div>

      <input type="checkbox"(change)="onPrivacyChanged($event)" style="width: 20px;" class="margin-top-30" />
      <ng-container i18n="@@register_agree_privacy">
          Confermo di aver letto l’informativa ai sensi dell’articolo art.13 del D.lgs. 196/03 di 1Control e acconsento al trattamento dei miei dati personali per le finalità indicate al punto 2 lettere a) b) c) d) e)
      </ng-container><br>

      <input type="checkbox"(change)="onTermsChanged($event)" style="width: 20px;" class="margin-top-10" />
      <ng-container i18n="@@register_agree_terms">
          Confermo di aver letto e accetto le condizioni del servizio
      </ng-container><br>
      
      <input type="checkbox"(change)="onMarketingChanged($event)" style="width: 20px;" class="margin-top-10" />
      <ng-container i18n="@@register_agree_marketing">
          Acconsento all’invio di comunicazioni promozionali tramite telefonate automatizzate e modalità assimilate di contatto (quali fax, e-mail, sms, mms, ecc.), oltre che tradizionali (come posta cartacea e telefonate con operatore) e relative a prodotti, servizi e offerte di 1Control e/o di società terze partner di 1Control senza che per questo motivo i dati vengano ceduti a terzi.
      </ng-container><br>

      <div class="margin-top-30">

        <a (click)="register(userEmail.value, userPassword.value, userPassword2.value)" class="button float-left">
          <ng-container i18n="@@register_register">Registrati</ng-container> <span><fa-icon icon="user"></fa-icon></span>
        </a>

        <p class="text-small text-error margin-top-10 margin-left-20 float-left" *ngIf="emailInvalid" > 
          <ng-container i18n="@@register_wrong_email">Email non valida</ng-container>
        </p>
          <p class="text-small text-error margin-top-10 margin-left-20 float-left" *ngIf="passwordInvalid" > 
            <ng-container i18n="@@register_wrong_password">La password deve essere lunga almeno 8 caratteri</ng-container>
        </p>
        <p class="text-small text-error margin-top-10 margin-left-20 float-left" *ngIf="passwordMismatch" > 
          <ng-container i18n="@@register_password_mismatch">Le password non coincidono</ng-container>
        </p>
        <p class="text-small text-error margin-top-10 margin-left-20 float-left" *ngIf="userAlreadyRegistered" > 
            <ng-container i18n="@@register_already_registered">L'indirizzo email inserito è già registrato</ng-container>
        </p>
        <p class="text-small text-error margin-top-10 margin-left-20 float-left" *ngIf="privacyNotAccepted" > 
            <ng-container i18n="@@register_privacy_not_accepted">Devi accettare l'informativa sulla privacy</ng-container>
        </p>
        <p class="text-small text-error margin-top-10 margin-left-20 float-left" *ngIf="termsNotAccepted" > 
            <ng-container i18n="@@register_terms_not_accepted">Devi accettare la condizioni del servizio</ng-container>
        </p>

      </div>

    </div>

    <app-loading-screen #registerloader [loading]="false" ></app-loading-screen>

  </div>

</section>

